import { ApprovalAction } from "./action";

const initialState = {
  Approvals: {},
  loading: false,
  error: null,
};

export const ApprovalReducer = (state = initialState, action) => {
  switch (action.type) {
    case ApprovalAction.GET_APPROVALS:
      return { ...state, loading: true, error: null };

    case ApprovalAction.GET_APPROVALS_SUCCESS:
      const data = {};
      action.payload.forEach((section) => {
        const pdfs = {};
        section.records.forEach((record) => {
          pdfs[record.year] = {
            pdf_embed: record.pdf_embed,
            pdf_url: record.pdf_url,
          };
        });
        data[section.title] = {
          title: section.title,
          subTitle: section.subTitle || "",
          pdfs,
        };
      });
      return { ...state, loading: false, Approvals: data };

    case ApprovalAction.GET_APPROVALS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
